<template>
  <div class="p-4 bg-white rounded-lg h-100" v-if="isDataLoaded">
    <DataTable
      :table_state="table_state"
      :store_names="store_names"
      :addComponent="componentForAdding"
      :editComponent="componentForEditing"
      :showDetailComponent="componentForDetails"
      :delete_url="delete_url"
      :urls="urls"
    />
  </div>
</template>

<script>
import DataTable from "@/own/components/DataTable.vue";
import {
  EXPORT_TABLE_DATA,
  SET_TABLE_FILTER,
  SET_TABLE_PAGE,
  SET_TABLE_PERPAGE,
  SET_TABLE_SORTBY,
  UPDATE_TABLE_DATA,
  UPDATE_TABLE_STRUCTURE,
} from "@/core/services/store/httpLogs.module";
import { SET_PAGE_LOADING } from "@/core/services/store/config.module";
import ShowDetails from "@/own/components/datatable/ShowDetails.vue";
export default {
  name: "HTTPlogs",
  components: { DataTable },
  data: () => ({
    componentForEditing: null,
    componentForAdding: null,
    componentForDetails: ShowDetails,
    delete_url: `/settings/http_logs/destroy`,
    table_state: {
      UPDATE_TABLE_STRUCTURE: UPDATE_TABLE_STRUCTURE,
      UPDATE_TABLE_DATA: UPDATE_TABLE_DATA,
      SET_TABLE_SORTBY: SET_TABLE_SORTBY,
      SET_TABLE_FILTER: SET_TABLE_FILTER,
      SET_TABLE_PERPAGE: SET_TABLE_PERPAGE,
      SET_TABLE_PAGE: SET_TABLE_PAGE,
      EXPORT_TABLE_DATA: EXPORT_TABLE_DATA,
    },
    store_names: {
      getTableFilters: "getHTTPLOGSTableFilters",
      getTableState: "getHTTPLOGSTableState",
      getTableData: "getHTTPLOGSTableData",
      getTableHeaders: "getHTTPLOGSTableHeaders",
      getTableProperties: "getHTTPLOGSTableProperties",
      getTableExportUrl: "getHTTPLOGSExportUrl",
      getTablePermissions: "getHTTPLOGSTablePermissions",
    },
    urls: {
      delete: `/settings/http_logs/destroy`,
      showUrl: "/settings/http_logs/show",
    },
  }),
  methods: {
    async initTableContent() {
      await this.$store.dispatch(this.table_state.UPDATE_TABLE_STRUCTURE, {});
      await this.$store.dispatch(this.table_state.UPDATE_TABLE_DATA, {});
    },
  },
  computed: {
    isDataLoaded: function () {
      return this.$store.getters[this.store_names.getTableData];
    },
  },
  beforeMount() {
    this.$store.commit(SET_PAGE_LOADING, true);
    this.initTableContent();
  },
};
</script>
